import { translateFn } from '../../../../../../../utils/translator.helper';
import { IColumnType, IDataTableColumn } from '../../../../../../../ui/gzDataTable/types';
import { html, TemplateResult } from 'lit';

import { DeviceControlDeviceClassType, DeviceControlPermissionsItem } from '@nirvana/shared/dtos/types/policies/common';
import {
  getAllPermissionLabel,
  getLabelByDeviceClassType,
  getDescriptionLabel,
} from '../../../../utils/uiSettings/deviceControl/device-control.values';

export enum ColumnKeys {
  DEVICE = 'deviceClass',
  DESCRIPTION = 'ruleName',
  PERMISSION = 'permissions',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.DEVICE,
      header: translateFn('Device Class'),
      columnType: IColumnType.DISPLAY,
      renderer: typeCellCustomRenderer.bind(this),
    },
    {
      key: ColumnKeys.DESCRIPTION,
      header: translateFn('Description'),
      columnType: IColumnType.DISPLAY,
      renderer: descriptionCellCustomRenderer.bind(this),
    },
    {
      key: ColumnKeys.PERMISSION,
      header: translateFn('Permission'),
      columnType: IColumnType.DISPLAY,
      renderer: permissionCellCustomRenderer.bind(this),
    },
  ];
}

export function typeCellCustomRenderer(
  content: DeviceControlDeviceClassType,
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  return html`
    <span
      class="cell-label text-medium"
      style="cursor: pointer; color: var(--blue-layout-400-primary);"
      @click="${() => this.onDevicePressed(rowIndex)}"
    >
      ${getLabelByDeviceClassType(content)}</span
    >
  `;
}
export function permissionCellCustomRenderer(
  content: DeviceControlPermissionsItem,
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  return html`
        <div class="cell-label" id="${column.key}-row${rowIndex}-form-field">
            ${getAllPermissionLabel(content)}
        </div>
  `;
}

export function descriptionCellCustomRenderer(
  content: string,
  column: IDataTableColumn,
  rowIndex: number
): TemplateResult {
  return html`
        <div class="cell-label" id="${column.key}-row${rowIndex}-form-field">
            ${getDescriptionLabel(content)}
        </div>`;
}
